import { HabitSchedule, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

export type GetScheduleCompletedOnDateOptions = {
  fullyCompleted?: boolean;
};

export const getScheduleCompletedOnDate = (
  schedule: HabitSchedule,
  date: Timestamp,
  { fullyCompleted }: GetScheduleCompletedOnDateOptions = {},
) => {
  const completedOnDay = schedule.entries?.find(
    (entry) =>
      entry.state === 'complete' &&
      !!entry.value &&
      isSameDay(entry.date, date),
  );

  if (schedule.frequency) {
    return (
      !!completedOnDay &&
      (completedOnDay.value ?? 0) >= schedule.completionTarget.count
    );
  }

  return (
    !!completedOnDay &&
    (!fullyCompleted ||
      (completedOnDay.value ?? 0) >= schedule.completionTarget.count)
  );
};
